































































import Vue from 'vue'
import Component from 'vue-class-component'
import UserCrud from '../components/UserCrud.vue'
import ExportUserDetails from '../components/ExportUserDetails.vue'
import DataTable from '../components/DataTable.vue'
import { Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { ArchivedPayload, Area, AreaOrderByInput, AreaWhereInput, Authority, AuthorityWhereInput, CrudDialogMode, DataTableAction, FetchAreasPayload, FetchAuthoritiesPayload, FetchUsersPayload, Filter, Role, User, QueryParams, FilterType, FilterField, AgeGroups } from '../utils/types'
import { DataTableHeader } from 'vuetify'
import { convertStringToEnum, daysAgo, daysAgoInISO, getDaysAgo, translate, getAge } from '@/utils/helpers'

@Component({
  components: { UserCrud, ExportUserDetails, DataTable }
})
export default class Users extends Vue {
  @Getter users!: User[]
  @Getter totalUsers!: number
  @Getter areas!: Area[]
  @Getter authorities!: Authority[]
  @Action fetchAuthorities!: (payload: FetchAuthoritiesPayload) => Promise<void>
  @Action fetchAreas!: (payload: FetchAreasPayload) => Promise<void>
  @Action fetchUsers!: (payload: FetchUsersPayload) => Promise<void>
  @Action createUser!: (payload: User) => Promise<boolean>
  @Action updateUser!: (payload: User) => Promise<boolean>
  @Action archiveUser!: (payload: ArchivedPayload) => Promise<boolean>
  orderBy = AreaOrderByInput.ID_DESC
  crudDialogMode = CrudDialogMode
  currentTab = 0
  currentCrudDialogMode = CrudDialogMode.NONE
  headers: DataTableHeader[] = [
    { text: 'אימייל', value: 'email' },
    { text: 'שם פרטי', value: 'firstName' },
    { text: 'שם משפחה', value: 'lastName' },
    { text: 'טלפון', value: 'phone', sortable: false },
    { text: 'תפקיד', value: 'hebrewRole' },
    { text: 'גיל', value: 'age' },
    { text: 'תאריך הרשמה', value: 'signUpDate' },
    { text: 'פעילות אחרונה', value: 'lastActive' },
    { text: 'אזור', value: 'closestArea.name' },
    { text: 'רשות', value: 'authority.name' }
  ]

  isExportFormVisible = false
  isLoading = false
  item: User = {}
  itemsPerPage = 100
  search = ''
  snackbar = false
  snackbarMessage = ''

  @Watch('currentTab')
  async onCurrentTabChange () {
    await this.fetchPage(1)
  }

  @Watch('$route.query')
  async onQueryChange () {
    await this.fetchPage(1)
  }

  async mounted () {
    await this.fetchData()
    await this.fetchPage(1)
  }

  closeDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.isExportFormVisible = false
    this.item = {}
  }

  handleClearAllFilters () {
    this.$router.replace({
      path: this.$route.path
    })
  }

  handleStringFilters (filter: Filter<string>) {
    switch (filter.field) {
      case FilterField.areaIds:
        this.closestAreaFilter = { idIn: filter.subItems.filter(i => i.isSelected)?.map(i => i.value) }
        break
      case FilterField.authorityIds:
        this.authorityFilter = { idIn: filter.subItems.filter(i => i.isSelected)?.map(i => i.value) }
        break
      default:
        break
    }
    this.fetchPage(1)
  }

  handleNumberFilters (filter: Filter<number>, value: number) {
    const date = value ? daysAgoInISO(value) : undefined
    switch (filter.field) {
      case FilterField.lastActivity:
        this.lastActivityFilter = date
        break
      case FilterField.createdAt:
        this.createdAtFilter = date
        break
      case FilterField.lastShiftLog:
        this.lastShiftLogFilter = date
        break
      default:
        break
    }
    this.fetchPage(1)
  }

  openDialog (mode: CrudDialogMode, item: User = {}) {
    this.item = item
    this.currentCrudDialogMode = mode
  }

  openExportDialog (item: User) {
    this.item = item
    this.isExportFormVisible = true
  }

  async executeUpdate (eventData: User) {
    return this.updateUser(eventData)
  }

  async executeDelete (eventData = '') {
    if (!eventData) return false
    return this.archiveUser({ id: eventData, isArchived: !this.isArchived })
  }

  async fetchPage (page: number): Promise<void> {
    this.isLoading = true
    await this.fetchUsers({
      limit: this.itemsPerPage,
      page: page,
      searchText: this.search.length ? this.search : undefined,
      isArchived: this.isArchived,
      isInFocusGroup: this.isInFocusGroup || undefined,
      createdAtGte: this.createdAtFilter,
      lastActivityGte: this.lastActivityFilter,
      lastShiftLogGte: this.lastShiftLogFilter,
      roles: this.rolesFilter,
      closestArea: this.closestAreaFilter,
      authority: this.authorityFilter,
      ages: this.agesFilter
    })
    this.isLoading = false
  }

  async fetchData (): Promise<void> {
    if (!this.areas?.length) {
      this.isLoading = true
      await this.fetchAreas({
        isArchived: false,
        orderBy: this.orderBy,
        basic: true
      })
    }
    if (!this.authorities?.length) {
      this.isLoading = true
      await this.fetchAuthorities({
        isArchived: false,
        basic: true
      })
    }
    this.isLoading = false
  }

  async handleSearch (search: string) {
    this.search = search
    this.fetchPage(1)
  }

  async handleSubmit (eventData: User) {
    let success = false
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        success = await this.executeCreate(eventData)
        break
      case CrudDialogMode.EDIT:
        success = await this.executeUpdate(eventData)
        break
      case CrudDialogMode.DELETE:
        success = await this.executeDelete(eventData.id)
        break
    }
    if (success) {
      this.snackbarMessage = 'הפעולה בוצעה בהצלחה'
      this.closeDialog()
    } else {
      this.snackbarMessage = 'הפעולה נכשלה. אנא ודאו את הטופס'
    }
    this.snackbar = true
  }

  async executeCreate (eventData: User) {
    return this.createUser(eventData)
  }

  get closestAreaFilter (): AreaWhereInput | undefined {
    const query: QueryParams = this.$route.query
    return query.areaIds ? { idIn: query.areaIds?.split(',') } : undefined
  }

  set closestAreaFilter (area: AreaWhereInput | undefined) {
    const query = {
      ...this.$route.query,
      areaIds: area?.idIn?.join(',')
    }
    if (!area?.idIn?.length) {
      delete query.areaIds
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get authorityFilter (): AuthorityWhereInput | undefined {
    const query: QueryParams = this.$route.query
    return query.authorityIds ? { idIn: query.authorityIds?.split(',') } : undefined
  }

  set authorityFilter (authority: AuthorityWhereInput | undefined) {
    const query = {
      ...this.$route.query,
      authorityIds: authority?.idIn?.join(',')
    }
    if (!authority?.idIn?.length) {
      delete query.authorityIds
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get agesFilter (): AgeGroups | undefined {
    const query: QueryParams = this.$route.query
    const ages = query.ages ? AgeGroups[query.ages] : undefined
    return ages
  }

  set agesFilter (ages: AgeGroups | undefined) {
    const query = {
      ...this.$route.query
    }
    if (ages && ages !== AgeGroups.EVERYONE) {
      query.ages = ages.toString()
    } else {
      delete query.ages
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get createdAtFilter (): string | undefined {
    const query: QueryParams = this.$route.query
    return query.createdAtGte
  }

  set createdAtFilter (date: string | undefined) {
    const query = {
      ...this.$route.query
    }
    if (date) {
      query.createdAtGte = date
    } else {
      delete query.createdAtGte
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get lastActivityFilter (): string | undefined {
    const query: QueryParams = this.$route.query
    return query.lastActivityGte
  }

  set lastActivityFilter (date: string | undefined) {
    const query = {
      ...this.$route.query,
      lastActivityGte: date
    }
    if (!date) {
      delete query.lastActivityGte
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get lastShiftLogFilter (): string | undefined {
    const query: QueryParams = this.$route.query
    return query.lastShiftLogGte
  }

  set lastShiftLogFilter (date: string | undefined) {
    const query = {
      ...this.$route.query,
      lastShiftLogGte: date
    }
    if (!date) {
      delete query.lastShiftLogGte
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת משתמש חדש'
      case CrudDialogMode.EDIT:
        return 'עריכת משתמש'
      case CrudDialogMode.DELETE:
        return this.isArchived ? 'להפעיל את המשתמש?' : 'להעביר לארכיון?'
    }
  }

  get dialog () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  get formattedUsers () {
    return this.users.map(u => ({
      ...u,
      hebrewRole: translate(u.role || Role.AUTHENTICATED),
      age: u.birthday ? getAge(u.birthday) : '-',
      signUpDate: u.createdAt ? new Date(u.createdAt || 0).toLocaleDateString('he-IL') : '-',
      lastActive: u.lastActivity ? new Date(u.lastActivity || 0).toLocaleDateString('he-IL') : '-'
    }))
  }

  get isArchived () {
    return this.currentTab === 2
  }

  get isInFocusGroup () {
    return this.currentTab === 1
  }

  get rolesFilter (): Role[] | undefined {
    const query: QueryParams = this.$route.query
    const roles = query.roles?.split(',')?.map(r => convertStringToEnum(Role, r)).filter(Boolean)
    return roles?.length ? roles as Role[] : undefined
  }

  set rolesFilter (roles: Role[] | undefined) {
    const query = {
      ...this.$route.query
    }
    if (roles?.length) {
      query.roles = roles.map(r => r.toString()).join(',')
    } else {
      delete query.roles
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get tableActions (): DataTableAction<User>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: this.openDialog.bind(this, CrudDialogMode.EDIT)
      },
      {
        text: this.isArchived ? 'הפעלה' : 'הקפאה',
        icon: this.isArchived ? 'mdi-backup-restore' : 'mdi-archive',
        handler: this.openDialog.bind(this, CrudDialogMode.DELETE)
      },
      {
        icon: 'mdi-file',
        text: 'ייצוא פרטי משתמש',
        handler: this.openExportDialog.bind(this)
      }
    ]
  }

  get filters (): (Filter<string> | Filter<number> | Filter<Role> |Filter<AgeGroups>)[] {
    return [
      {
        action: (filter: Filter<Role>) => {
          this.rolesFilter = filter.subItems.filter(i => i.isSelected).map(i => i.value)
        },
        text: 'תפקידים',
        type: FilterType.CHECKBOX,
        field: FilterField.roles,
        subItems: Object.values(Role).map(r => ({
          text: translate(r),
          value: r,
          isSelected: !!this.rolesFilter?.includes(r)
        }))
      },
      {
        action: (filter: Filter<string>) => {
          this.handleStringFilters(filter)
        },
        text: 'אזורי תעסוקה',
        type: FilterType.CHECKBOX,
        field: FilterField.areaIds,
        subItems: this.areas?.map((a: Area) => ({
          text: a.name || '',
          value: a.id || '',
          isSelected: !!this.closestAreaFilter?.idIn?.includes(a.id ?? '')
        })) || []
      },
      {
        action: (filter: Filter<string>) => {
          this.handleStringFilters(filter)
        },
        text: 'רשויות',
        type: FilterType.CHECKBOX,
        field: FilterField.authorityIds,
        subItems: this.authorities?.map((a: Authority) => ({
          text: a.name || '',
          value: a.id || '',
          isSelected: !!this.authorityFilter?.idIn?.includes(a.id ?? '')
        })) || []
      },
      {
        action: (filter: Filter<AgeGroups>, value?: AgeGroups) => {
          this.agesFilter = value
        },
        text: 'גיל',
        type: FilterType.RADIO,
        field: FilterField.ages,
        value: this.agesFilter,
        subItems: Object.values(AgeGroups).map(j => ({
          text: translate(j),
          value: j,
          isSelected: this.agesFilter === j
        }))
      },
      {
        action: (filter: Filter<number>, value?: number) => {
          this.handleNumberFilters(filter, value || 0)
        },
        text: 'תאריך הרשמה',
        type: FilterType.RADIO,
        field: FilterField.createdAt,
        value: this.createdAtFilter ? getDaysAgo(new Date(this.createdAtFilter)) : 0,
        subItems: [
          {
            text: 'הכל',
            value: 0,
            isSelected: !this.createdAtFilter
          },
          {
            text: 'נרשמו ב-30 יום האחרונים',
            value: 30,
            isSelected: this.createdAtFilter ? new Date(this.createdAtFilter) === daysAgo(30) : false
          }
        ]
      },
      {
        action: (filter: Filter<number>, value?: number) => {
          this.handleNumberFilters(filter, value || 0)
        },
        text: 'פעילות אחרונה',
        type: FilterType.RADIO,
        field: FilterField.lastActivity,
        value: this.lastActivityFilter ? getDaysAgo(new Date(this.lastActivityFilter)) : 0,
        subItems: [
          {
            text: 'הכל',
            value: 0,
            isSelected: !this.lastActivityFilter
          },
          {
            text: 'פעילים ב-180 יום האחרונים',
            value: 180,
            isSelected: this.lastActivityFilter ? getDaysAgo(new Date(this.lastActivityFilter)) === 180 : false
          },
          {
            text: 'פעילים ב-30 יום האחרונים',
            value: 30,
            isSelected: this.lastActivityFilter ? getDaysAgo(new Date(this.lastActivityFilter)) === 30 : false
          }
        ]
      },
      {
        action: (filter: Filter<number>, value?: number) => {
          this.handleNumberFilters(filter, value || 0)
        },
        text: 'רישום משמרת אחרונה',
        type: FilterType.RADIO,
        field: FilterField.lastShiftLog,
        value: this.lastShiftLogFilter ? getDaysAgo(new Date(this.lastShiftLogFilter)) : 0,
        subItems: [
          {
            text: 'הכל',
            value: 0,
            isSelected: !this.lastShiftLogFilter
          },
          {
            text: 'ב-30 יום האחרונים',
            value: 30,
            isSelected: this.lastShiftLogFilter ? getDaysAgo(new Date(this.lastShiftLogFilter)) === 30 : false
          }
        ]
      }
    ]
  }
}
